// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NJsn_vV94kwEQFov{height:100%}.NJsn_vV94kwEQFov .UsbvchkVag0ZaJ2l{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `NJsn_vV94kwEQFov`,
	"grid": `UsbvchkVag0ZaJ2l`
};
export default ___CSS_LOADER_EXPORT___;
